export default __webpack_public_path__ + "static/media/Image_OB_Pins_CFR@3x.59ac8c7d.png";